module.exports = __webpack_public_path__ + "static/middle_ship-f148e2d65b67bfa9b2dbcd035b62d8e5.jpg";